import React from "react";
import style from "./style.module.css";

const DescriptionTitle = ({ detailsList, currentLanguage }) => {
  return (
    <div className={style.details_description_title}>
      <h1>{detailsList.sale?.["title_" + currentLanguage]}</h1>
    </div>
  );
};

export default DescriptionTitle;
